var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pencileSvg{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.994 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pencileSvg",
    d: "M1.832,24.662A.833.833,0,0,1,1,23.738l.642-5.832a.833.833,0,0,1,.242-.492L15.513,3.783a2.666,2.666,0,0,1,3.774,0l2.591,2.591a2.666,2.666,0,0,1,0,3.774L8.256,23.771a.833.833,0,0,1-.492.242l-5.832.642Zm5.832-1.483ZM3.274,18.372l-.5,4.516,4.516-.5L20.7,8.974a1,1,0,0,0,0-1.416l-2.6-2.6a1,1,0,0,0-1.416,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pencileSvg",
    d: "M21.8,12.836a.833.833,0,0,1-.592-.242L16.031,7.4a.837.837,0,1,1,1.183-1.183L22.4,11.412a.833.833,0,0,1-.608,1.425Z",
    transform: "translate(-2.468 -0.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pencileSvg",
    width: 9.173,
    height: 1.666,
    transform: "translate(7.081 17.405) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pencileSvg",
    d: "M27.164,28.666H13.833a.833.833,0,0,1,0-1.666H27.164a.833.833,0,1,1,0,1.666Z",
    transform: "translate(-2.003 -4.004)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencile);
export default __webpack_public_path__ + "static/media/pencile.9ebe1884.svg";
export { ForwardRef as ReactComponent };